import gql from 'graphql-tag';
export default gql`
  mutation deleteWetSignature($applicationId: String!, $wetSignatureObjName: String!) {
    deleteWetSignature(applicationId: $applicationId, wetSignatureObjName: $wetSignatureObjName) {
      url
    }
  }
`;
